import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useSearchParams } from 'react-router-dom';
import RoslinBranding from '../components/RoslinBranding';

const LoginPage: React.FC = () => {
  const { isAuthenticated, login } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-content">
          <RoslinBranding variant="large" showTagline={false} />
          
          <div className="login-header">
            <h1>Welcome to Roslin Quiz Platform</h1>
            <p>Please sign in to access the admin features</p>
          </div>

          {error === 'auth_failed' && (
            <div className="error-message">
              <p>Authentication failed. Please try again.</p>
            </div>
          )}
          {error === 'auth_not_configured' && (
            <div className="error-message">
              <p>Microsoft sign-in is not configured yet. Please contact an administrator.</p>
            </div>
          )}

          <div className="login-actions">
            <button 
              className="social-login-btn google-login-btn"
              onClick={() => login('google')}
            >
              <svg className="google-icon" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google (Tecorien)
            </button>
            <button
              className="social-login-btn microsoft-login-btn"
              onClick={() => login('microsoft')}
            >
              <svg className="microsoft-icon" viewBox="0 0 24 24" aria-hidden="true">
                <rect x="2" y="2" width="9" height="9" fill="#f25022" />
                <rect x="13" y="2" width="9" height="9" fill="#7fba00" />
                <rect x="2" y="13" width="9" height="9" fill="#00a4ef" />
                <rect x="13" y="13" width="9" height="9" fill="#ffb900" />
              </svg>
              Sign in with Microsoft (Roslin)
            </button>
            <p className="login-provider-hint">
              Use <strong>@tecorien.com</strong> with Google and <strong>@roslin.us</strong> with Microsoft.
            </p>
          </div>

          <div className="login-footer">
            <p>
              By signing in, you agree to our terms of service and privacy policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 